/**
 * Encoding UTF8 ⇢ base64
 * From: https://stackoverflow.com/a/30106551
 *
 * This can be decoded from .NET by calling Base64Helper.Base64Decode()
 *
 * @param plainText
 * @returns
 */
export function b64EncodeUnicode(plainText) {
    return btoa(encodeURIComponent(plainText).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode(parseInt(p1, 16));
    }));
}
/**
 * Decoding base64 ⇢ UTF8
 * From: https://stackoverflow.com/a/30106551
 *
 * This can be encoded from .NET by calling Base64Helper.Base64Encode()
 *
 * @param base64EncodedData
 * @returns
 */
export function b64DecodeUnicode(base64EncodedData) {
    return decodeURIComponent(Array.prototype.map.call(atob(base64EncodedData), function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}
